export default "__VITE_ASSET__f6a647e5__"